import { AddReportTypeValues } from 'modules/reportType/types/reportTypes';

export const REPORTTYPE_ACTION_PREFIX = 'REPORTTYPES';
export const REPORTTYPE_FILTER_KEY = 'reporttype';

export const addReportTypeInitValues: AddReportTypeValues = {
  name: '',
};
